// @flow
import React from 'react';
import './FormInput.scss';

type Props = {
  label: string,
  onKeyUp: () => void,
  defaultValue: string,
  isError: boolean,
  onInput: ({ value: string }) => void,
  errorMessage: string,
};

const FormInput = (props: Props) => {
  return (
    <div className="form-input-component">
      <input
        id={props.label}
        onKeyUp={props.onKeyUp}
        defaultValue={props.defaultValue}
        type="text"
        className={`text-input${props.isError ? ' is-error' : ''}`}
        ref={(input) => props.onInput(input)}
      />
      {props.isError ? (
        <div className="error">
          <span>
            <p className="p__meta text">
              <span>{props.errorMessage}</span>
            </p>
          </span>
          <svg id="warning" className="svg-icon" viewBox="0 0 24 24" role="presentation" aria-hidden="true">
            <title>icon-warning</title>
            <path d="M12 13.75a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 1 0v6a.5.5 0 0 1-.5.5z" />
            <circle cx="12" cy="16.25" r="1" />
            <path d="M12 1A11 11 0 1 1 1 12 11 11 0 0 1 12 1m0-1a12 12 0 1 0 12 12A12 12 0 0 0 12 0z" />
          </svg>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default FormInput;
